"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormToggleButton", {
    enumerable: true,
    get: function() {
        return FormToggleButton;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormToggleButton = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { label, value: propsValue, onChange, className, icon: Icon, ...props } = param;
    const { hasError } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors } = (0, _Theme.useTheme)();
    const [localValue, setLocalValue] = (0, _react.useState)(propsValue !== null && propsValue !== void 0 ? propsValue : false);
    const value = (0, _react.useMemo)(()=>propsValue !== null && propsValue !== void 0 ? propsValue : localValue, [
        propsValue,
        localValue
    ]);
    const handleClick = ()=>{
        setLocalValue(!value);
        onChange === null || onChange === void 0 ? void 0 : onChange(!value);
    };
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("button", {
        ref: ref,
        ...props,
        onClick: handleClick,
        className: _style.default.dynamic([
            [
                "809e99df741fe846",
                [
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.blue[10],
                    colors.blue[60],
                    colors.status.danger.primary
                ]
            ]
        ]) + " " + ("button ".concat(value ? "button--active" : "", " ").concat(hasError ? "button--error" : "", " ").concat(className !== null && className !== void 0 ? className : "").trim() || "")
    }, Icon != null && /*#__PURE__*/ _react.default.createElement(Icon, {
        size: 16,
        fill: "#000",
        className: _style.default.dynamic([
            [
                "809e99df741fe846",
                [
                    colors.transparent.black[10],
                    colors.transparent.black[5],
                    colors.blue[10],
                    colors.blue[60],
                    colors.status.danger.primary
                ]
            ]
        ])
    }), label), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "809e99df741fe846",
        dynamic: [
            colors.transparent.black[10],
            colors.transparent.black[5],
            colors.blue[10],
            colors.blue[60],
            colors.status.danger.primary
        ]
    }, ".button.__jsx-style-dynamic-selector{background:#fff;font-size:16px;line-height:24px;color:#000;border:1px solid ".concat(colors.transparent.black[10], ";-webkit-border-radius:100px;-moz-border-radius:100px;border-radius:100px;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:8px;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;padding:.5rem 1.25rem;gap:.5rem;cursor:pointer}.button.__jsx-style-dynamic-selector:not(.button--active):hover{background-color:").concat(colors.transparent.black[5], "}.button--active.__jsx-style-dynamic-selector{background-color:").concat(colors.blue[10], ";border-color:").concat(colors.blue[60], "}.button--error.__jsx-style-dynamic-selector{border-color:").concat(colors.status.danger.primary, "}")));
});
FormToggleButton.displayName = "FormToggleButton";

//# sourceMappingURL=FormToggleButton.js.map